import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const StarRatingWeb = createAsyncThunk('StarRatingWeb', async (data) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `start_rating_wthout_token`,
            headers: { "Content-Type": "application/json"}

        })
        return res
    } catch (error) {
        return error.response
    }
})

const StarRatingWebSlice = createSlice({
    name: 'StarRatingWeb',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(StarRatingWeb.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            }  else {
                state.data = [];
            }
        });
        builder.addCase(StarRatingWeb.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default StarRatingWebSlice.reducer; 